import { useEffect } from 'react';

const ORIGIN = 'https://7kchain.cn';

interface SeoHeadProps {
  title: string;
  description: string;
  keywords: string;
  path: string;
  type?: string;
  jsonLd?: Record<string, unknown>;
}

const upsertMeta = (attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel: string, href: string) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function SeoHead({
  title,
  description,
  keywords,
  path,
  type = 'website',
  jsonLd,
}: SeoHeadProps) {
  useEffect(() => {
    const url = `${ORIGIN}${path}`;
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'keywords', keywords);
    upsertMeta('name', 'robots', 'index,follow');
    upsertMeta('property', 'og:type', type);
    upsertMeta('property', 'og:site_name', '爆料直播网');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', url);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertLink('canonical', url);

    const scriptId = 'baoliao-page-jsonld';
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();
    if (jsonLd) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = scriptId;
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
  }, [title, description, keywords, path, type, jsonLd]);

  return null;
}